import * as z from "zod/v4";

export const deletePurchaseOrderViewFolder = {
  name: "deletePurchaseOrderViewFolder" as const,
  input: z.object({ folderId: z.string() }),
  output: z.object({}),
};
